module.exports = __webpack_public_path__ + "img/randabstand-DIN4141.abf1a070.svg";